import { BaseI18nManager } from "../../../../i18n";

type Section = { [key: string]: string; };

export type Labels = {

    menu: string;
    view: string;
    view_all: string;
    read_more: string;
    home: Section;
    tournaments: Section;
    events: Section;
    blog: Section;
    about: Section;
    store: Section;
    footer: Section;

}

export const i18nManager = new BaseI18nManager<Labels>({
    en_UK: require("./en_UK.json"),
});
